import { ConfigFilterItem, ConfigItem } from 'Core/interfaces'

export enum ManifestFilterFields {
	pickupDateFrom = 'pickupDateFrom',
	pickupDateTo = 'pickupDateTo',
	serviceSiteId = 'serviceSiteId'
}

export enum ManifestMainSearchFields {
	manifestDocumentNumber = 'manifestDocumentNumbers',
	disposalFacilityName = 'disposalFacilityNames'
}

export declare namespace Manifest {
	interface Basic {
		id: number
		manifestDocumentId: number
		manifestDocumentNumber: BasicString
		pickupDate: BasicString
		disposalFacility: NullableEntity | null
		serviceSite: NullableEntity | null
	}

	namespace Filter {
		interface Config {
			[ManifestFilterFields.pickupDateFrom]: ConfigFilterItem<string, null>
			[ManifestFilterFields.pickupDateTo]: ConfigFilterItem<string, null>
			[ManifestFilterFields.serviceSiteId]: ConfigFilterItem<string, string>
		}
	}

	namespace Search {
		interface Config {
			[ManifestMainSearchFields.manifestDocumentNumber]: ConfigItem<
				ManifestMainSearchFields,
				Result['manifestDocumentNumbers'][number]
			>
			[ManifestMainSearchFields.disposalFacilityName]: ConfigItem<
				ManifestMainSearchFields,
				Result['disposalFacilityNames'][number]
			>
		}

		interface Result {
			[ManifestMainSearchFields.manifestDocumentNumber]: {
				documentNumber: string
				manifestId: number
				disposalFacilityName: string
			}[]
			[ManifestMainSearchFields.disposalFacilityName]: {
				disposalFacilityName: string
				documentNumber: string
				manifestId: number
			}[]
		}
	}
}
